import { CriteriaBase } from '@/shared/models/CriteriaBase.model';
import { StatutContratAchat } from '@/shared/enums/StatutContratAchat.enum';
import { StatutFiltreCertification } from '@/shared/models/StatutFiltreCertification';

/**
 * Liste des filtres possible pour récupérer la liste des contrats d'achat.
 */
export class ContratAchatCriteria extends CriteriaBase {
    /**
     * La date de signature.
     */
    public dateSignature: string | null = null;

    /**
     * La date de mise en service.
     */
    public dateMiseEnService: string | null = null;

    /**
     * Les identifiants des contrats à exclure.
     */
    public idsExclus: number[] | null = null;

    /**
     * Le champ de recherche pour filtrer sur différentes propriétés du contrat d'achat.
     */
    public recherche: string | null = null;

    /**
     * Le statut du contrat d'achat.
     */
    public statut: StatutContratAchat = StatutContratAchat.EnService;

    /**
     * L'identifiant de l'utilisateur sélectionné
     */
    public utilisateurId: number | null = null;

    /**
     * Le statut de la recherche par certification
     */
    public StatutFiltreCertification: StatutFiltreCertification = StatutFiltreCertification.Tous;
}
